/**
 * Embed Wrapper Component - For embedding charts externally
 * Provides isolated chart functionality for iframe embedding
 */

import React from 'react';

interface EmbedWrapperProps {
  chartType: 'rolling' | 'quarterly' | 'yoy' | 'acquisitions';
}

export const EmbedWrapper: React.FC<EmbedWrapperProps> = ({ chartType }) => {
  const mapChartType = (type: string) => {
    switch (type) {
      case 'rolling':
        return 'yoy-funding';
      case 'quarterly':
        return 'yoy-funding-breakdown';
      case 'yoy':
        return 'yoy-market-volume';
      case 'acquisitions':
        return 'yoy-acquisitions';
      default:
        return 'yoy-funding';
    }
  };

  return (
    <div style={{ padding: '20px', background: '#FFFFFF' }}>
      {/* SmartChart component requires data and config props, not the current props */}
      {/* TODO: Fix this to properly load and pass data to SmartChart */}
      <div>
        <h2>{`${chartType.charAt(0).toUpperCase() + chartType.slice(1)} Chart`}</h2>
        <p>Chart type: {mapChartType(chartType)}</p>
        <p>Embed functionality needs to be reimplemented with proper data loading</p>
      </div>
    </div>
  );
};